import EITable from './EITable';
export default EITable;
